import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { LocalLoadEvent } from '../../../shared/local-load-event.model';
import { Moment } from 'moment';
import * as moment from 'moment';

@Component({
  selector: 'app-load-event-eta-update',
  templateUrl: './load-event-eta-update.component.html',
  styleUrls: ['./load-event-eta-update.component.scss']
})
export class LoadEventEtaUpdateComponent implements OnInit, OnChanges {

  @Input()
  event: LocalLoadEvent;

  oldValue: Moment;

  newValue: Moment;

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.event) {
      this.updateValues();
    }
  }

  updateValues() {
    this.oldValue = this.event.oldValue ? moment(this.event.oldValue) : null;
    this.newValue = this.event.newValue ? moment(this.event.newValue) : null;
  }

}
